/**
 * Unread-alert count for the tab bar. Reads the same `['alerts']` query the feed
 * uses (so it is one shared cache entry, not a second request) and compares it
 * against the localStorage watermark. Renders nothing when there is nothing
 * unread, so the tab label stays clean.
 */

import { useAlerts } from '../lib/queries';
import { readLastSeen, unreadCount } from '../lib/alerts-unread';

export default function AlertsBadge() {
  const { data } = useAlerts();
  const alerts = (data?.pages ?? []).flatMap((p) => p.alerts);
  const count = unreadCount(alerts, readLastSeen());
  if (count === 0) return null;
  return (
    <span className="tab-badge" aria-label={`${count} unread alerts`}>
      {count}
    </span>
  );
}
